module.exports = __webpack_public_path__ + "img/logo_black.a9c2270c.png";